import React, { Context } from "react";
import { AppContextInterface, AppContext } from "../app-context-provider";
import ArchiveCategory, { ArchiveCategoryProps } from "./archive-category";
import SectionTitle from "../components/section-title";
import { createCategories, generateSectionId } from "../helpers/layout-helpers";
import { CategorisedArchiveProps } from "./categorised-archve";

export interface PhotoArchiveProps extends CategorisedArchiveProps {
    columns: number;
    component: React.ComponentType;
    fitContent: boolean;
}

export interface PhotoArchiveState {
    columns: number;
    selectedItems: any[];
}

class PhotoArchive extends React.Component<PhotoArchiveProps> {
    pageBodyRef: React.RefObject<any> = React.createRef();
    static contextType: Context<AppContextInterface | null> = AppContext;
    public context!: AppContextInterface;
    public state: PhotoArchiveState = { columns: 3, selectedItems: [] };

    componentDidMount() {
        if (this.state.columns !== this.props.columns) {
            this.setState({ columns: this.props.columns });
        }
    }

    renderCategories() {
        const singlePhotos = this.props.itemChildren?.filter(
            (item) => item.type === "Photo"
        );
        const collections = this.props.itemChildren?.filter(
            (item) => item.type === "PhotoCollection"
        );
        let categories: ArchiveCategoryProps[] = createCategories(
            singlePhotos!,
            this.props.component
        );
        let results = [];

        collections?.forEach((col: any) => {
            let newTag: ArchiveCategoryProps = { heading: col.title, ...col };
            console.log(col)
            results.push([
                <ArchiveCategory {...newTag}>
                    {col.photos.map((photo: any) => {
                        const Component = this.props.component;
                        return (
                            <Component
                                key={photo.originalImage?.key}
                                onClick={this.onClick.bind(this)}
                                {...photo}
                                hideTitle={this.props.hideTitle}
                                selected={this.isSelected(photo.id)}
                            />
                        );
                    })}
                </ArchiveCategory>,
            ]);
        });

        if (results.length === 0) {
            let newTag: ArchiveCategoryProps = { ...this.props };
            results.push([
                <ArchiveCategory {...newTag}>
                    {singlePhotos.map((photo: any) => {
                        const Component = this.props.component;
                        return (
                            <Component
                                key={photo.originalImage?.key}
                                onClick={this.onClick.bind(this)}
                                {...photo}
                                hideTitle={this.props.hideTitle}
                                selected={this.isSelected(photo.id)}
                            />
                        );
                    })}
                </ArchiveCategory>,
            ]);
        } else {
            categories?.forEach((col: any) => {
                let newTag: ArchiveCategoryProps = {
                    heading: col.title,
                    ...col,
                };
                results.push([
                    <ArchiveCategory {...newTag}>
                        {col.photos.map((photo: any) => {
                            const Component = this.props.component;
                            return (
                                <Component
                                    key={photo.originalImage?.key}
                                    onClick={this.onClick.bind(this)}
                                    {...photo}
                                    selected={this.isSelected(photo.id)}
                                    hideTitle={this.props.hideTitle}
                                />
                            );
                        })}
                    </ArchiveCategory>,
                ]);
            });
        }

        return results;
    }

    addColumn() {
        let columns = this.state.columns + 1;
        if (columns > 4) {
            columns = 4;
        }
        this.setState({ columns });
    }

    removeColumn() {
        let columns = this.state.columns - 1;
        if (columns < 1) {
            columns = 1;
        }
        this.setState({ columns });
    }

    selectItem(id: number) {
        const item = this.props.itemChildren.find((item) => item.id === id);
        if (!item) {
            return;
        }
        this.setState({ selectedItems: [...this.state.selectedItems, item] });
    }

    deselectItem(id: number) {
        this.setState({
            selectedItems: this.state.selectedItems.filter(
                (item) => item.id !== id
            ),
        });
    }

    onClick(id: number) {
        if (this.isSelected(id)) {
            this.selectItem(id);
        } else {
            this.deselectItem(id);
        }
    }

    isSelected(id: number) {
        return this.state.selectedItems.some((item) => item.id === id);
    }

    render() {
        let className = `page-container ${this.props.type.toLowerCase()}`;
        // let maxColumns = mediaQuery.isDesktop() ? 4 : 2;
        if (this.props.sideMenuTitle) {
            className += " can-scroll-to";
        }

        let key = window.btoa(this.props.slug);
        return (
            <div
                key={"photo-archive-" + key}
                className={className}
                id={generateSectionId(this.props)}
            >
                <SectionTitle
                    title={this.props.mainTitle}
                    key={"title-" + this.props.id}
                />
                {this.props.pageDescription && (
                    <div
                        className="text-content"
                        dangerouslySetInnerHTML={{
                            __html: this.props.pageDescription,
                        }}
                    />
                )}
                {/* <div className="column-selctor-container">
                    <label>Columns: </label>

                        <div className="column-selector">
                            <button className="button primary"  disabled={this.state.columns <= 1}  onClick={this.removeColumn.bind(this)}>-</button>
                            <span>{this.state.columns}</span>
                            <button  className="button primary"  disabled={this.state.columns >= maxColumns} onClick={this.addColumn.bind(this)}>+</button>
                        </div>
                    </div> */}
                {this.renderCategories()}

            </div>
        );
    }
}

export default PhotoArchive;
